import React from 'react';
import DokanTablePillTags from '../DokanTablePillTags';
import DokanTableItemPublishedDate from './DokanTableItemPublishedDate';
import DokanTableItemViews from './DokanTableItemViews';

/*
Props : 
status = 'Product Status' <string>
date: date <string>
views : product View <number>
*/
const DokanTableItemStatus = ({ status, date, views, dateLabel }) => (
    <div>
        <div>
            <DokanTablePillTags variant={status}>
                {status === 'publish' ? 'Online' : 'Offline'}
            </DokanTablePillTags>
        </div>
        <div className="mt-12px">
            <DokanTableItemPublishedDate date={date}>{dateLabel}</DokanTableItemPublishedDate>
        </div>
        <div className="mt-12px">
            <DokanTableItemViews views={views} />
        </div>
    </div>
);

export default DokanTableItemStatus;
